import _toConsumableArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "options", "selectedValue", "onOptionSelect"];
import React, { useContext } from 'react';
import { HeaderNavigationMenuContentBodyOptionsCategory, HeaderNavigationMenuContentBodyOptionsItem, HeaderNavigationMenuContentBodyOptionsRoot } from './style';
import { useComponentTheme } from '../../../../../utils/hooks';
import { HEADER_NAVIGATION_MENU_CONTENT_BODY_OPTIONS_CLASS_PREFIX, headerNavigationMenuContentBodyOptionsCategory, headerNavigationMenuContentBodyOptionsItem, headerNavigationMenuContentBodyOptionsRoot } from './constants';
import HeaderNavigationMenuContentContext from '../HeaderNavigationMenuContentContext';
import { useHeaderNavigationMenuContentBodyOptionsClassName } from './utils';
import { headerNavigationMenuContentBodyOptionsTheme } from './theme';

var setActiveClass = function setActiveClass(isActive) {
  return isActive ? 'active' : '';
};

export var HeaderNavigationMenuContentBodyOptions = function HeaderNavigationMenuContentBodyOptions(_ref) {
  var className = _ref.className,
      options = _ref.options,
      selectedValue = _ref.selectedValue,
      onOptionSelect = _ref.onOptionSelect,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var _useContext = useContext(HeaderNavigationMenuContentContext),
      isExpanded = _useContext.isExpanded,
      setIsExpanded = _useContext.setIsExpanded;

  var theme = useComponentTheme(HEADER_NAVIGATION_MENU_CONTENT_BODY_OPTIONS_CLASS_PREFIX, headerNavigationMenuContentBodyOptionsTheme);
  var classOverride = useHeaderNavigationMenuContentBodyOptionsClassName(HEADER_NAVIGATION_MENU_CONTENT_BODY_OPTIONS_CLASS_PREFIX, className);

  var handleClick = function handleClick(_ref2) {
    var event = _ref2.event,
        selectedOption = _ref2.selectedOption;

    if (onOptionSelect) {
      onOptionSelect(selectedOption);
    }

    if (isExpanded && setIsExpanded) {
      setTimeout(function () {
        return setIsExpanded(false);
      }, 0);
    }
  };

  var handleOnClick = function handleOnClick(selectedOption) {
    return function (event) {
      return handleClick({
        event: event,
        selectedOption: selectedOption
      });
    };
  };

  return React.createElement(HeaderNavigationMenuContentBodyOptionsRoot, Object.assign({
    "data-testid": headerNavigationMenuContentBodyOptionsRoot
  }, restProps, {
    theme: theme,
    className: classOverride.Root
  }), options.map(function (option) {
    if (!option.category) {
      var _value = option.value,
          _label = option.label;
      return React.createElement(HeaderNavigationMenuContentBodyOptionsItem, {
        theme: theme,
        className: "".concat(classOverride.Item, " ").concat(setActiveClass(selectedValue === _value)),
        key: _value,
        "data-testid": headerNavigationMenuContentBodyOptionsItem,
        onClick: handleOnClick(option),
        isActive: selectedValue === _value
      }, _label);
    }

    var value = option.value,
        label = option.label,
        items = option.options;
    var optionItems = [];
    var categoryItem = React.createElement(HeaderNavigationMenuContentBodyOptionsCategory, {
      theme: theme,
      className: classOverride.Category,
      key: value,
      "data-testid": headerNavigationMenuContentBodyOptionsCategory
    }, label);

    if (items) {
      optionItems = items.map(function (item) {
        var optionValue = item.value,
            optionLabel = item.label;
        return React.createElement(HeaderNavigationMenuContentBodyOptionsItem, {
          theme: theme,
          className: "".concat(classOverride.Item, " ").concat(setActiveClass(selectedValue === optionValue)),
          key: optionValue,
          "data-testid": headerNavigationMenuContentBodyOptionsItem,
          onClick: handleOnClick(item),
          isActive: selectedValue === optionValue
        }, optionLabel);
      });
    }

    return [categoryItem].concat(_toConsumableArray(optionItems));
  }));
};
HeaderNavigationMenuContentBodyOptions.defaultProps = {};